import type { ReportingAuthClient } from "@reporting/rp-auth-client-v2";

export class Auth {
	
	constructor(public client: ReportingAuthClient) { }

	async logout() {
		const { logout_url } = await this.client.logout();
		if (logout_url) {
			// SAML2 session: the SP logout endpoint clears the cookies and goes on to the identity provider
			window.location.assign(logout_url);
			return;
		}
		this.client.redirectToLogin();
	}

}
